import { isAfter, isBefore, isValid, parse, startOfDay } from 'date-fns';
import { DateFormatOptions } from 'shared/types/date-format-options';

export type ParseDateInputBounds = {
  minDate?: Date;
  maxDate?: Date;
};

export const parseDateInput = (
  value: string,
  dateFormat: DateFormatOptions,
  referenceDate: Date,
  { minDate, maxDate }: ParseDateInputBounds = {},
): Date | null => {
  if (value.length !== dateFormat.length) {
    return null;
  }

  const parsed = parse(value, dateFormat, referenceDate);
  if (!isValid(parsed)) {
    return null;
  }

  const day = startOfDay(parsed);
  if (minDate && isBefore(day, startOfDay(minDate))) {
    return null;
  }

  if (maxDate && isAfter(day, startOfDay(maxDate))) {
    return null;
  }

  return parsed;
};
